interface GradientTextProps {
  children: React.ReactNode;
  as?: React.ElementType;
  startColor?: string;
  endColor?: string;
  angle?: number;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * A reusable component for displaying text with a gradient effect.
 */
const GradientText: React.FC<GradientTextProps> = ({
  children,
  as: Component = 'span',
  startColor = '#A61E69',
  endColor = '#6366F1',
  angle = 102,
  disabled = false,
  style = {},
  className = '',
  ...props
}) => {
  const gradientStyles = disabled
    ? {
        display: 'inline-block',
        ...style,
      }
    : {
        background: `linear-gradient(${angle}deg, ${startColor}, ${endColor})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        display: 'inline-block',
        ...style,
      };

  return (
    <Component className={className} style={gradientStyles} {...props}>
      {children}
    </Component>
  );
};

export default GradientText;
